import React from "react";
import { Link } from "react-router-dom";
import { withAlert } from "react-alert";

import DataSender from "../lib/DataSender";

class QRCreate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      delay: 100,
      result: "",
      name: "",
      number: "",
      regiment: "",
    };
    this.createUser = this.createUser.bind(this);

    this.alert = this.props.alert;
    this.ds = new DataSender();
  }

  componentWillMount() {
    this.ds
      .unitLst()
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          data: res,
        });
      });
  }

  //===

  handleScan = (data) => {
    this.setState({
      result: data,
    });
  };

  handleError = (err) => {
    throw err;
  };

  handleChange = (e) => {
    let value = e.target.value;
    if (e.target.name === "phone_number") value = this.phoneFomatter(value);
    else if (e.target.name === "dt_number") value = this.dtFormmater(value);
    this.setState({
      [e.target.name]: value,
    });
  };

  //===

  phoneFomatter = (value) => {
    if (value === undefined) return;
    let x = value
      .replace(/[^0-9]/g, "")
      .replace(
        /(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,
        "$1-$2-$3"
      )
      .replace("--", "-");
    return x;
  };

  dtFormmater = (value) => {
    if (value === undefined) return;
    let x = value
      .replace(/[^0-9]/g, "")
      .replace(/([0-9]{2})?([0-9]{8})$/, "$1-$2");
    return x;
  };

  //===

  createUser = () => {
    this.ds
      .insertSoldier(this.state)
      .then(() => {
        this.ds
          .accessPhone(this.state.phone_number)
          .then((res) => res.json())
          .then((res) => {
            this.alert.show("정상처리되었습니다.");
            this.props.history.push({
              pathname: "/QRresult",
              state: res,
            });
          });
      })
      .catch((e) => {
        if (e.message.includes("Missing"))
          this.alert.show("누락된 정보가 있습니다.");
        if (e.message === "Validation error")
          this.alert.show("전화번호와 군번을 확인해주세요.");
      });
  };

  render() {
    return (
      <div>
        <div className="wrapper">
          <h1>QR코드를 생성하기 위한 정보 입력</h1>
          <form autoComplete="off">
            <div className="group">
              <input
                type="text"
                required="required"
                onChange={this.handleChange}
                name="name"
              />
              <span className="highlight"></span>
              <span className="bar"></span>
              <label>이름 ( 홍길동 )</label>
            </div>
            <div className="group">
              <input
                type="text"
                maxLength="13"
                required="required"
                value={this.state.phone_number}
                onChange={this.handleChange}
                name="phone_number"
              />
              <span className="highlight"></span>
              <span className="bar"></span>
              <label>전화번호 ( 010 - XXXX - XXXX )</label>
            </div>
            <div className="group">
              <input
                type="text"
                required="required"
                maxLength="11"
                value={this.state.dt_number}
                onChange={this.handleChange}
                name="dt_number"
              />
              <span className="highlight"></span>
              <span className="bar"></span>
              <label>군번 ( 00 - 번호 )</label>
            </div>
            <div className="group">
              <input
                type="text"
                required="required"
                maxLength="6"
                onChange={this.handleChange}
                name="birth"
              />
              <span className="highlight"></span>
              <span className="bar"></span>
              <label>생년월일 ( 000000 )</label>
            </div>
            <div className="group custom-select">
              <select
                id="styledSelect1"
                onChange={this.handleChange}
                name="level"
              >
                <option defaultValue>계급</option>
                <option value="훈련병">훈련병</option>
                <option value="이등병">이등병</option>
                <option value="일등병">일등병</option>
                <option value="상등병">상등병</option>
                <option value="병장">병장</option>
              </select>
            </div>
            <div className="group custom-select">
              <select
                id="styledSelect1"
                onChange={this.handleChange}
                name="armyUnitId"
              >
                <option defaultValue>부대(소속)</option>
                {this.state.data ? (
                  this.state.data.map((x) => {
                    return (
                      <option value={x.id} key={x.id.toString()}>
                        {x.unitName}
                      </option>
                    );
                  })
                ) : (
                  <></>
                )}
              </select>
            </div>
          </form>
        </div>
        <div className="qrcreate-buttons">
          <div className="qrcreate-button1">
            <button className="button" onClick={this.createUser}>
              <p>QR생성하기</p>
            </button>
          </div>
          <Link to="/Main" className="qrcreate-button2">
            <button className="button">
              <p>취소</p>
            </button>
          </Link>
        </div>
      </div>
    );
  }
}

export default withAlert()(QRCreate);
